import {
  isVehicleLocationType,
  PILLAR_BOUNDARIES
} from 'src/constants/pillarBoundaries'
import { IConfiguration, ILocation, SizeFilter } from 'src/types/graphql'

/** Uses the search size bands defined by the server's ElasticSearch SIZES. */
export function similarSizeFilter(
  config: IConfiguration
): SizeFilter | undefined {
  // Parking dimensions do not describe storage needs; retain the pillar query.
  if (isVehicleLocationType(config.locationType)) return undefined
  const area = (config.size?.width ?? 0) * (config.size?.length ?? 0)
  if (!Number.isFinite(area) || area <= 0) return undefined
  if (area <= 4) return SizeFilter.Xsmall
  if (area <= 9) return SizeFilter.Small
  if (area <= 18) return SizeFilter.Medium
  if (area <= PILLAR_BOUNDARIES.selfStorageMaxSqm) return SizeFilter.Large
  if (area <= 500) return SizeFilter.Commercial
  if (area <= PILLAR_BOUNDARIES.warehouseMaxSqm) return SizeFilter.Industrial
  return SizeFilter.Nave
}

/** Recommendations can fall back to unfiltered inventory. The summary is
 * resolved against the original query, so only keep actual matches.
 */
export function isSimilarLocation(
  location: ILocation,
  currentId: string
): boolean {
  return (
    location.id !== currentId && (location.configSummary?.activeCount ?? 0) > 0
  )
}
